import React, { Component } from 'react'
import { func } from 'prop-types'
import { translate } from 'react-i18next'
import { Input } from '../ui/inputs/Input'
import { PhoneInput } from '../ui/inputs/PhoneInput'
import { SignUp as validation } from './validators'
import { Birthdate } from '../ui/inputs/Birthdate'
import { CheckBox } from '../ui/inputs/CheckBox'
import { CountryInput } from '../ui/inputs/CountryInput'
import config from '../../config'
import { stores, view } from '../../stores'
import { validateReferences } from '../../utilities/validators'
import { getErrorTranslation } from '../../utilities/errors'
import { CouponCodeInput } from '../ui/inputs/CouponCodeInput'

class SignUpComponent extends Component {
  constructor () {
    super()
    this.state = {
      password: '',
      isLoading: false
    }
  }

  validate () {
    const { isValid } = validateReferences(this.refs)
    const { t } = this.props
    if (!isValid) {
      this.setState({ error: t('common:fields:incomplete_form') })
      return false
    }
    this.setState({ error: '' })
    return true
  }

  async doSignUp () {
    if (this.state.isLoading) return

    const { t, onRegistration } = this.props
    this.setState({ isLoading: true })
    try {
      await stores.authentication.register({
        password: this.state.password,
        referralCode: stores.search.search.sponsor,
        // Pro business referral (apport d'affaire L2) - independent from sponsor system
        proBusinessReferralCode: stores.search.search.proBusinessReferral
      })
      // Those values are not accepted by registration endpoint. We need to put them afterwards.
      if (stores.authentication.registration.phone || stores.authentication.registration.gardenSurface) {
        stores.account.update = {
          phone: stores.authentication.registration.phone,
          gardenSurface: stores.authentication.registration.gardenSurface
        }
        await stores.account.updateAccount()
      }
      // Clear pro business referral code after successful registration
      stores.search.clearProBusinessReferral()
      onRegistration()
    } catch (e) {
      this.setState({ error: getErrorTranslation(t, e) })
    }
    this.setState({ isLoading: false })
  }

  updateValue (name, value) {
    const registration = stores.authentication.registration
    registration[name] = value
  }

  render () {
    const { t } = this.props
    const registration = stores.authentication.registration
    const isReferralCodeRegistration = !!stores.search.search.sponsor

    return (
      <div>
        {this.state && this.state.error !== '' && <p className='form__errormessage'>{this.state.error}</p>}
        <Input value={registration.lastName} onChange={(v) => this.updateValue('lastName', v)} ref='lastName' label={t('common:fields:lastname')} name='lastName' type='text' rules={validation.lastName} />
        <Input value={registration.firstName} onChange={(v) => this.updateValue('firstName', v)} ref='firstName' label={t('common:fields:firstname')} name='firstName' type='text' rules={validation.firstName} />
        <PhoneInput value={registration.phone} onChange={(v) => this.updateValue('phone', v)} ref='phone' label={t('common:fields:phone')} name='phone' type='text' rules={validation.phone} required />
        <Input value={stores.authentication.email} onChange={(v) => this.updateValue('email', v)} ref='email' label={t('common:fields:email')} name='email' type='text' rules={validation.email} />
        {
          isReferralCodeRegistration
          ? '' // do not ask for a password if the user used a sponsor code
          : <span>
            <Input ref='password' value={this.state.password} onChange={(v) => this.setState({ password: v })} label={t('common:fields:password')} name='password' type='password' rules={validation.password} />
            <Input ref='confirm' associated={() => this.refs['password'].state} label={t('common:fields:confirm')} name='passwordConfirm' type='password' rules={validation.passwordConfirm} />
          </span>
        }
        <Birthdate value={registration.birthdate} onChange={(v) => this.updateValue('birthdate', v)} ref='birthdate' label={t('common:fields:birthdate')} name='birthdate' type='text' rules={validation.birthdate} />
        <CountryInput value={registration.country} onChange={(v) => this.updateValue('country', v)} ref='country' label={t('common:fields:country')} name='country' required />
        <CountryInput value={registration.nationality} onChange={(v) => this.updateValue('nationality', v)} ref='nationality' label={t('common:fields:nationality')} name='nationality' required />
        <CouponCodeInput onChange={(v) => this.updateValue('couponCodeId', v)} />
        <CheckBox ref='agree' name='agree_cga' required>
          { t('common:fields:accept') } <a href={`${config.cgu_url}`} target='_blank'>{t('common:fields:conditions')}</a>
        </CheckBox>
        <CheckBox ref='newsletter' name='newsletter' checked={registration.newsletter} onChange={(v) => this.updateValue('newsletter', v)}>
          { t('common:signup:newsletter') }
        </CheckBox>
        <button onClick={() => this.validate() && this.doSignUp()} className='btn--default layout--centered signup__btn'>{ t('common:signup:register') }</button>
        {this.state && this.state.error !== '' && <p className='form__errormessage' style={{ textAlign: 'center' }}>{this.state.error}</p>}
      </div>
    )
  }
}

SignUpComponent.propTypes = {
  t: func,
  onRegistration: func
}

export const SignUp = translate()(view(SignUpComponent))



// WEBPACK FOOTER //
// ./src/components/authentication/SignUp.js